import {Country} from "@model/country";

export interface PaysDto {
  id: string;
  code: string;
  codeSiel: string;
  libelle: string;
  nationaliteF: string;
  nationaliteM: string;
}

export const PaysDtoMapper = {
  toDomain: (dto: PaysDto): Country => ({
    id: dto.id,
    code: dto.code,
    codeSiel: dto.codeSiel,
    name: dto.libelle,
    nationalityF: dto.nationaliteF,
    nationalityM: dto.nationaliteM,
  })
};